module.exports = __webpack_public_path__ + "img/resources.a6c87950.png";